var phone_number = {};
module['exports'] = phone_number;
phone_number.area_code = require("./area_code");
phone_number.exchange_code = require("./exchange_code");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_US/phone_number/index.js
// module id = 1323
// module chunks = 0